import { render, staticRenderFns } from "./GalaxyFrame.vue?vue&type=template&id=675eb480&scoped=true"
import script from "./GalaxyFrame.vue?vue&type=script&lang=js"
export * from "./GalaxyFrame.vue?vue&type=script&lang=js"
import style0 from "./GalaxyFrame.vue?vue&type=style&index=0&id=675eb480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675eb480",
  null
  
)

export default component.exports